// extracted by mini-css-extract-plugin
export default {"container":"StockBadge_container__yPg5P","containerSmall":"StockBadge_containerSmall__h16fw","text":"StockBadge_text__fSiKB","textSmall":"StockBadge_textSmall__DKFK3"};